import { render, staticRenderFns } from "./MinigenresTitleBrief.vue?vue&type=template&id=4b2f6646&scoped=true&"
import script from "./MinigenresTitleBrief.vue?vue&type=script&lang=js&"
export * from "./MinigenresTitleBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f6646",
  null
  
)

export default component.exports